export enum ChatMessagesDelay {
  ChatMessagesDelayMs = 500,
}
